import { render, staticRenderFns } from "./DevListForm.vue?vue&type=template&id=4d1a4b02&"
import script from "./DevListForm.vue?vue&type=script&lang=js&"
export * from "./DevListForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports